import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.QBooksBudgets.BudgetActionsMenu', {
    activateMenuName: 'Activate Budget',
    activateMenuTitle: 'Activate this budget to start checking Bills / POs / Expenses against it',
    deactivateMenuName: 'Deactivate Budget',
    deactivateMenuTitle: 'Deactivate this budget to stop checking Bills / POs / Expenses against it',
    showSettingsMenuName: 'Budget settings',
    showSettingsMenuTitle: 'Change the settings of the budget',
    refreshMenuName: 'Refresh',
    refreshMenuTitle: 'Pull the latest version of this budget from QBooks Online',
    hasBeenActivated: 'Budget has been activated',
    hasBeenDeactivated: 'Budget has been deactivated',
    syncIsDisabled: 'Budget sync with QuickBooks Online is disabled',
});
